import SkorDefaultLoader from "../../../../assets/img/skorDefaultLoader.gif";
import styles from "../authenticateYourId.module.css";

const LoadingScreen = ({ message }: { message: string }) => (
  <div className={styles.customKycUploading}>
    <div className="defaultSkorLoaderParent">
      <img
        src={SkorDefaultLoader}
        className="defaultSkorLoader"
        alt="Loading"
      />
    </div>
    <p>{message}</p>
  </div>
);

export default LoadingScreen;
